/*
  columns 新增参数 needMoment   自动转时间戳 默认为false 
  innerHeight 必传  滚动条产生的高度
  excelCallback  参数类型 function   不传默认不展示图标   
  pdfCallback   参数类型 function   不传默认不展示图标      
*/
import React, { Component } from 'react'
import { Empty, Pagination, Table } from 'antd';
import moment from 'moment';
import {WWUtils} from "@/tools/index";
var language = localStorage.getItem('language')
import "./globalTable.scss"
export default class WWTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      columns: this.props.columns || []
    }
  }
  componentWillReceiveProps(nextProps) {
    const { columns } = nextProps
    const columnsLength = columns.length
    const newColumns = columns.map((item, index) => {
      //日期特殊处理
      if (item.needMoment) {
        item.render = (text) => {
          if (!text) return
          return moment(text).format('YYYY-MM-DD HH:mm:ss')
        }
      }
      // 不支持最小宽度 默认最小宽度为150px
      !item.width && (item.width = '150px')
      //双击复制
      item.onCell = record => {
        return {
          onClick: event => { }, // 点击行
          onDoubleClick: event => {
            event.preventDefault()
            event.nativeEvent.stopImmediatePropagation();
            WWUtils.copy(event.target.innerText)
          },
          onContextMenu: event => { },
          onMouseEnter: event => { }, // 鼠标移入行
          onMouseLeave: event => { },
        };
      }
      return item
    })
    this.setState({
      columns: newColumns
    })
  }
  render() {
    const { count, pageSize, currentPage, onShowSizeChange, parentId, hiddenPagination, width, height, innerHeight, exportExcel, minHeight,onChange } = this.props;
    const { columns } = this.state
    let footer = <div className="new_app_pagination">
      {!hiddenPagination ? <Pagination
        {...this.props}
        style={{ display: 'inline-block' }}
        showSizeChanger
        pageSize={pageSize ? pageSize : 10}
        onChange={onChange}
        onShowSizeChange={onShowSizeChange}
        current={currentPage}
        total={count}
        showTotal={function () {
          return `${Strings.total || "共"} ${count} ${(Strings.num || '条') }`
        }}
      /> : null}
    </div>;
    if (hiddenPagination && !exportExcel) {
      footer = null
    }
    let locale = {
      emptyText: <div className='empty_text' ><Empty description={<p>{Strings.empty}</p>} /></div>
    };
    return <div className={`new_app_table_content`} id={parentId} style={{ height: height || 'auto', width: width ? width : 'auto', minHeight: minHeight||'' }}>
      <Table className={`new_app_table`}  {...this.props} scroll={{ y: innerHeight-109, x: '100%' }}  locale={locale} pagination={false} columns={columns} />
      {footer}
    </div>
  }
}